/* import style */
import "../scss/style.scss";

/* import images */
let requireImages = require.context('../assets/images', true, /\.(png|jpg)$/);
requireImages.keys().forEach(requireImages);

/* import fonts */
let requireFonts = require.context('../assets/fonts', true, /\.(woff|woff2)$/);
requireFonts.keys().forEach(requireFonts);

/* import data */
let requireData = require.context('../assets/data', true, /\.json$/);
requireData.keys().forEach(requireData);

/* import php */
// let requirePHP = require.context('../include', true, /\.php$/);
// requirePHP.keys().forEach(requireData);

/* import movie */
let requireMovie = require.context('../assets/movie', true, /\.mp4$/);
requireMovie.keys().forEach(requireMovie);



/* import gobal modules */
import SmoothScroll from 'smooth-scroll';

/* import modules */
// import { ReactApp } from './react-app.jsx';
// import { iframeDeferResize } from './modules/iframe-functions';
import { headerVideo } from './modules/header-video';
import { sectionData } from "./modules/show-section";

/* additional scripts */

window.onload = init;

/*starter function */
function init() {
    
    /* smooth scroll */
    let scroll = new SmoothScroll('a[href*="#"]');
    let show = new sectionData();

    // Due to design changes, no need for react anymore
    // let shows = new ReactApp();
    // iframeDeferResize();

    headerVideo();
}